<template>
    <page>
        <module>
            <view-list ref="view" work-type="5" selector :view-config="auth('b_aftersale_outlet_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="网点名称">
                            <c-input name="outlet_name"></c-input>
                        </m-search-item>
                        <m-search-item label="网点地址">
                            <c-input name="outlet_address"></c-input>
                        </m-search-item>
                        <m-search-item label="状态">
                            <c-checkbox-group name="status" :options="disableEnableDic"></c-checkbox-group>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_aftersale_outlet_edit')" prepend-icon="tf-add" @click="$refs.outletEdit.open()">新增网点</c-button>
                    <c-button v-if="auth('b_aftersale_outlet_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_aftersale_outlet_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                
                <template #otherOperate>
                    <c-button v-if="auth('b_aftersale_outlet_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
                </template>

                <!--启禁用状态-->
                <template #status="{data}">
                    <c-switch v-if="auth('b_aftersale_outlet_edit')" v-model="data.status" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                    <c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
                </template>

                <!--负责人 -->
                <template #principal_user_name="{data}">
                    <span v-if="!data.principal_user_name" >-</span>
                    <c-tags v-else :value="data.principal_user_name"></c-tags>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="200"
                        button-limit="3"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_aftersale_outlet_edit')" icon="tf-edit" @click="$refs.outletEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_outlet_edit')" icon="tf-delete" @click="removeOutlet(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--编辑网点信息弹窗-->
            <aftersale-outlet-edit ref="outletEdit" @resolve="$refs.view.$refs.list.update()"></aftersale-outlet-edit>
        </module>
    </page>
</template>

<script>
import AftersaleAftersaleOutletEdit from "@/pages/aftersale/aftersale_outlet_edit.vue";
import {mapState} from "vuex";

export default {
    components: {aftersaleOutletEdit: AftersaleAftersaleOutletEdit},
    computed: {
        // 获取dictName选项数据
        ...mapState(['disableEnableDic']),
    },
    data() {
        return {
            defaultSearchData: {
                'status': [1]
            }
        }
    },

    methods: {
        /******删除网点***********/
        removeOutlet(data){
            this.$confirm({
                message:'确认删除网点【'+data.outlet_name+'】？删除后不可恢复',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/aftersale/outlet/delete',
                        data: {id:data.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message:'删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.view.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        /******网点启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/aftersale/outlet/update_status',
                data: {
                    id: data.id,
                    status: state ? 2 : 1
                },
                success: (data, message) => {
                    this.$message({
                        message: message,  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>
